import { Component, Input } from '@angular/core';
import { Editor } from 'primeng/editor';

@Component({
    selector: 'c-modal-videos',
    templateUrl: './modal-videos.component.html',
    styleUrl: './modal-videos.component.css',
    standalone: false
})
export class ModalVideosComponent {
  visible = false;

  @Input() editor!: Editor;

  range!: { index: number; length: number };

  open() {
    const quill = this.editor.getQuill(); // Obtén la instancia de Quill
    this.range = quill.getSelection(); // Obtén la posición del cursor
    this.visible = true;
  }
  close(url: string) {
    this.visible ? this.add(url) : '';
    this.visible = false;
  }

  private add(url: string) {
    const quill = this.editor.getQuill(); // Obtén la instancia de Quill
    const range = quill.getSelection(); // Obtén la posición actual del cursor
    const index = range ? range.index : quill.getLength(); // Índice donde se insertará
    let videoUrl = '';
    if (url.includes('youtube.com') || url.includes('youtu.be'))
      videoUrl = 'https://www.youtube.com/embed/' + this.extractYouTubeId(url);
    else videoUrl = url;
    // Inserta el Blot personalizado para el video
    quill.insertEmbed(index, 'video', videoUrl);
    quill.insertText(index + 1, '\n', 'user');
    quill.setSelection(index + 2, 0);
    // Opcional: Mover el cursor después del enlace
    this.visible = false;
  }

  private extractYouTubeId = (url: string): string => {
    // Expresión regular para capturar el ID del video
    const regex = /(?:v=|youtu\.be\/|youtube\.com\/embed\/)([^&?\/]+)/;
    const match = url.match(regex);
    return match ? match[1] : '';
  };
}
